import { render, staticRenderFns } from "./FormAddressComponent.vue?vue&type=template&id=0fd72e29&scoped=true&"
import script from "./FormAddressComponent.vue?vue&type=script&lang=js&"
export * from "./FormAddressComponent.vue?vue&type=script&lang=js&"
import style0 from "./FormAddressComponent.vue?vue&type=style&index=0&id=0fd72e29&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd72e29",
  null
  
)

export default component.exports